import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createManualRule: {
		id: 'automation-menu.popup.run-rule.manual-rules.rule-list.create-manual-rule',
		defaultMessage: 'Add a manually triggered automation',
		description: 'Link to create a new manual rule, positioned at the bottom of the rule list.',
	},
});
